import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1f1f69a4"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "course-wrapper"
};
const _hoisted_2 = {
  class: "course-content"
};
const _hoisted_3 = {
  class: "course-data"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "link-list"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, [/*#__PURE__*/_createTextVNode("资源中心 "), /*#__PURE__*/_createElementVNode("span", {
  class: "english-menu"
}, "/ Resource Center")])], -1));

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "btn-text"
}, "更多", -1));

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-chakanquanbu"
}, null, -1));

const _hoisted_7 = {
  class: "course-list"
};
const _hoisted_8 = {
  key: 1,
  class: "no-data"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CardHeader = _resolveComponent("CardHeader");

  const _component_ResourceCard = _resolveComponent("ResourceCard");

  const _component_Empty = _resolveComponent("Empty");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_CardHeader, {
    bodyStyle: {
      background: 'none'
    },
    openOut: true,
    link: "\n            https://hikeweb.zhihuishu.com/RSRCcenter/resourceCenter/resourceManage/resourceIndex?schoolId=1204\n          "
  }, {
    left: _withCtx(() => [_hoisted_4]),
    right: _withCtx(() => [_hoisted_5, _hoisted_6]),
    _: 1
  }), _createElementVNode("div", _hoisted_7, [$data.resourceList && $data.resourceList.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($data.resourceList, resource => {
    return _openBlock(), _createBlock(_component_ResourceCard, {
      class: "home-course-card",
      "resource-data": resource,
      key: resource.id,
      "show-label": true,
      userInfo: $props.userInfo
    }, null, 8, ["resource-data", "userInfo"]);
  }), 128)) : (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_Empty)]))])])])]);
}